import type { AdditionalConditionName } from './types';

const constructQueryParam = (primaryTreatment: string) =>
  `?com.purposemed.bypass.primary_treatment=${primaryTreatment}`;

export const INTAKE_PATH_BY_CONDITION: Record<AdditionalConditionName, string> =
  {
    hair_loss: '/efa/fl/hair-loss-intake',
    pe: '/efa/fl/premature-ejaculation-intake',
    ed: '/efa/fl/erectile-dysfunction-intake',
    hsv: '/efa/fl/hsv-intake',
  };

export const REFILL_PATH_BY_CONDITION: Record<AdditionalConditionName, string> =
  {
    hair_loss: '/efa/fl/hair-loss-refill',
    pe: '/efa/fl/premature-ejaculation-refill',
    ed: '/efa/fl/erectile-dysfunction-refill',
    hsv: '/efa/fl/hsv-refill',
  };

export const getAdditionalConditionFlowLink = (
  conditionName: AdditionalConditionName,
  primaryTreatment: string,
  isRefillFlow: boolean,
): string | undefined => {
  const pathMap = isRefillFlow
    ? REFILL_PATH_BY_CONDITION
    : INTAKE_PATH_BY_CONDITION;
  const basePath = pathMap[conditionName];
  if (!basePath) return undefined;
  return `${basePath}${constructQueryParam(primaryTreatment)}`;
};
